import { html, LitElement, nothing, type PropertyValueMap, unsafeCSS } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import type { Banner } from '../../../app/package/base/cms/package/cms-domain';
import style from './ui-slider-desktop.css?inline';
import '../ui-banner/ui-banner';
import '../ui-slider/ui-slider';

const CName = 'ui-slider-desktop';

@customElement(CName)
export class UISliderDesktop extends LitElement {
  static readonly styles = unsafeCSS(style);

  @property({ type: Boolean }) loggedIn?: boolean;
  @property({ type: Array }) banners: Banner[] = [];
  @state() small_banners: Banner[] = [];
  @state() filtered_banners: Banner[] = [];

  protected willUpdate(changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>): void {
    if (changedProperties.has('banners') && this.banners) {
      const small: Banner[] = [];
      const filtered: Banner[] = [];
      for (const banner of this.banners) {
        if (banner.small_image) {
          small.push(banner);
        } else {
          filtered.push(banner);
        }
      }
      this.small_banners = small;
      this.filtered_banners = filtered;
    }
  }

  render() {
    return html`
      <div class="banners">
        <ui-slider
          class="slider"
          .loggedIn=${this.loggedIn}
          .isDesktop=${true}
          .banners=${this.filtered_banners}
        ></ui-slider>
        ${this._renderSmallBanners()}
      </div>
    `;
  }

  private _renderSmallBanners() {
    if (this.small_banners.length)
      return html`
        <div class="slides">
          <ui-banner
            class="slide banner-logged-in"
            .isSmall=${true}
            .banner=${this.small_banners[0]}
            .position=${0}
          ></ui-banner>
          <ui-banner
            class="slide banner-logged-in"
            .isSmall=${true}
            .banner=${this.small_banners[1]}
            .position=${1}
          ></ui-banner>
        </div>
      `;

    return nothing;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UISliderDesktop;
  }
}
